import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const LS = "stancor_nav_layout";
const EVT = "nav-layout-changed";
const read = () => { try { return JSON.parse(localStorage.getItem(LS) || "null"); } catch { return null; } };

/** Admin sidebar layout + this user's pins. Cached in localStorage so the sidebar paints instantly; refreshed on mount and on `nav-layout-changed`. */
export function useNavLayout(token) {
  const [state, setState] = useState(() => read() || { layout: null, pins: [] });

  const refresh = useCallback(() => {
    if (!token) return;
    api.getNavLayout().then((r) => { setState(r.data); try { localStorage.setItem(LS, JSON.stringify(r.data)); } catch {} }).catch(() => {});
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => { window.addEventListener(EVT, refresh); return () => window.removeEventListener(EVT, refresh); }, [refresh]);

  const togglePin = useCallback((key) => {
    const cur = state.pins || [];
    const next = cur.includes(key) ? cur.filter((k) => k !== key) : [...cur, key];
    if (next.length > 6) { toast.error("You can pin at most 6 items"); return; }
    setState((s) => ({ ...s, pins: next }));
    api.saveNavPins(next).then((r) => { const d = { ...state, pins: r.data.pins }; try { localStorage.setItem(LS, JSON.stringify(d)); } catch {} })
      .catch(() => { setState((s) => ({ ...s, pins: cur })); toast.error("Could not save pin"); });
  }, [state]);

  return { layout: state.layout, pins: state.pins || [], togglePin, refresh };
}

export const notifyNavLayoutChanged = () => window.dispatchEvent(new Event(EVT));
